import { render, staticRenderFns } from "./warningDetailPage.vue?vue&type=template&id=15b2b4ee&scoped=true"
import script from "./warningDetailPage.vue?vue&type=script&lang=js"
export * from "./warningDetailPage.vue?vue&type=script&lang=js"
import style0 from "./warningDetailPage.vue?vue&type=style&index=0&id=15b2b4ee&prod&lang=scss&scoped=true"
import style1 from "./warningDetailPage.vue?vue&type=style&index=1&id=15b2b4ee&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b2b4ee",
  null
  
)

export default component.exports